// extracted by mini-css-extract-plugin
export default {"titleStat":"voteStat_titleStat__oaZoE"};